"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTypographyWithMatch = void 0;
var react_1 = require("react");
function useTypographyWithMatch(_a) {
    var text = _a.text, substring = _a.substring;
    var subStringStart = (0, react_1.useMemo)(function () { return text.indexOf(substring); }, [substring, text]);
    var substringEnd = (0, react_1.useMemo)(function () { return subStringStart + substring.length; }, [substring.length, subStringStart]);
    var startSlice = (0, react_1.useMemo)(function () { return text.substring(0, subStringStart); }, [subStringStart, text]);
    var endSlice = (0, react_1.useMemo)(function () { return text.substring(substringEnd); }, [substringEnd, text]);
    var hasMatch = subStringStart !== -1;
    return {
        startSlice: hasMatch ? startSlice : text,
        endSlice: hasMatch ? endSlice : '',
        hasMatch: subStringStart !== -1,
    };
}
exports.useTypographyWithMatch = useTypographyWithMatch;
